(function (window) { /* eslint-disable-line */
  window.__CWT__ = typeof __CWT__ === 'object' ? __CWT__ : {}; /* eslint-disable-line */

  if (!window.__CWT__.cookiePolicyInstance) { /* eslint-disable-line */
    const body = document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.src = '/assets/cookie-policy/cookie-policy-widget.js';
    script.async = true;
    script.onload = () => {
      __CWT__.cookiePolicyInstance = window.__CWT__.CookiePolicy();/* eslint-disable-line */

      const link = document.querySelector('.ConfirmCookie__details-link');
      if (link) link.setAttribute('rel', 'nofollow');
      const paragraph = document.querySelector('.ConfirmCookie__message_paragraph');
      if (paragraph) paragraph.appendChild(link);

      const btn = document.querySelector('.ConfirmCookie__agree-button');
      if (btn) btn.innerHTML = '<span>OK</span>';
    };

    body.appendChild(script);
  }
}(window));
